var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('contact-form-pre-register',{attrs:{"show":_vm.show,"form-class":"contact-form"},on:{"submitted":function($event){return _vm.$router.push('home')}}})}
var staticRenderFns = []

export { render, staticRenderFns }